import { PublishMessage } from "../../util/SocketIOClient";
import { BackendACCRole} from "./../backend/BackendACCRole";
import { UserWithRole } from '../frontend/FrontendSettings';
import { DataConnectorCompany } from "../DataConnectorCompany";
export class FrontendProjectRolesJobMessage extends PublishMessage {
    status!: string;
    accountID!: string;
    roles!: BackendACCRole[];
    usersWithRoles!: UserWithRole[];
    companies!: DataConnectorCompany[];
    public static sClassName = 'FrontendProjectRolesJobMessage'; //to keep className correct even after code minification
    public get className() {
        return FrontendProjectRolesJobMessage.sClassName;
    }
}